import React, { memo, useMemo } from 'react';
import Spacer from 'design-system/Spacer';
import { useAppSelector } from 'store/hooks';
import { selectFeedPriority, selectIsCreditScoreFirstInFeed, } from 'reducers/selectors/organise';
import CreditScoreFeedCard from 'features/credit-score/components/CreditScoreFeedCard';
import Analytics from './analytics/Analytics';
import Subscriptions from './transactions/Subscriptions';
import Transactions from './transactions/Transactions';
import CashbackCard from './CashbackCard';
import FeedGroupsSection from './FeedGroupsSection';
const FeedContent = ({ latestTransactions }) => {
    const organizedFeedArr = useAppSelector(selectFeedPriority);
    // in first position the card renders in the Feed screen under the overview
    const isCreditScoreFirst = useAppSelector(selectIsCreditScoreFirstInFeed);
    const priorityItemMap = useMemo(() => ({
        transactions: latestTransactions?.length ? (<Transactions key="Transactions" data={latestTransactions}/>) : (<React.Fragment key="Transactions"/>),
        analytics: <Analytics key="Analytics"/>,
        subscriptions: <Subscriptions key="Subscriptions"/>,
        completeSetup: <React.Fragment key="CompleteSetup"/>,
        groups: <FeedGroupsSection key="FeedGroupsSection"/>,
        cashback: <CashbackCard key="CashbackCard"/>,
        creditScore: (<CreditScoreFeedCard key="CreditScoreFeedCard" inFeedContent/>),
    }), [latestTransactions]);
    return (<>
      <Spacer h={8}/>
      {organizedFeedArr.priority
            .filter((item) => !(item === 'creditScore' && isCreditScoreFirst))
            .map((item) => priorityItemMap[item] || null)}
    </>);
};
export default memo(FeedContent);
